document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function(e){
    const openBtn = e.target.closest('.modal-link');
    const closeBtn = e.target.closest('.close');
    const modalMain = document.querySelector('.modal-main');
    if(openBtn){
      e.preventDefault();
      document.cookie.split(";").forEach(function(c) {
        const cookie = c.split("=")[0].trim();
        if (
          cookie.toLowerCase().includes("hulk") ||
          cookie.toLowerCase().includes("form") ||
          cookie.toLowerCase().includes("px")
        ) {
          document.cookie =
            cookie +
            "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
        }
      });
      modalMain.classList.add('active');
      document.body.style.overflow='hidden';
    }
    if(closeBtn){
      modalMain.classList.remove('active');
      document.body.style.overflow='';
    }
    if(e.target.classList.contains('modal-main')){
      modalMain.classList.remove('active');
      document.body.style.overflow='';
    }
  });
});